import { useLocation } from 'react-router-dom'
import { DatePicker, Label, MenuContent, Radio, Stack } from 'src/app/components'
import { useFilterMenuContentParticipantHook } from './FilterMenuContentParticipant.hook'

export interface FilterMenuContentParticipantProps {
  withTime: boolean
  withStatus: boolean
  withStatusSuspended: boolean
  withStatusDeleted: boolean
  withStatusActive: boolean
}

function FilterMenuContentParticipant(props: FilterMenuContentParticipantProps) {

  const location = useLocation();
  const state = useFilterMenuContentParticipantHook()
  const statusMaster = state.master.getStatusMaster(props)

  const renderStatusItem = (item: typeof state.master.luckyDrawParticipantStatuses[0]) => {
    const mappedLabel = mapStatusLabel(item.label);
    const mappedValue = mapStatusLabel(item.value);
    return (
      <Radio
        {...state.filterContext.registerRadio({ name: 'status', value: mappedValue })}
        label={mappedLabel}
        key={item.value}
      />
    )
  }

  const mapStatusLabel = (status: string): string => {
    const statusMap: Record<string, string> = {
      Suspended: 'Suspended',
      Active: 'Active',
      Deleted: 'Deleted',
    };

    const statusKeyMap: Record<string, string> = {
      SUSPENDED: 'SUSPEND',
      ACTIVE: 'ACTIVE',
      DELETED: 'DELETED',
    };

    // Check if the status matches the event, apply mapping if true; else return as is
    if (extractEvent() === 'event') {
      return statusMap[status] || status;
    } else if (extractEvent() === 'session') {
      return statusMap[status] || statusKeyMap[status];
    }
    return status; // Return the original status if the condition is not met
  };

  // Extract the `event` part from the URL
  const extractEvent = () => {
    const pathSegments = location.pathname.split('/');
    return pathSegments[pathSegments.length - 1]; // Get the last segment as `event`
  };

  const renderRadioYesNo = (name: string) => {
    return <Stack direction='row'>
      <div className='flex-1'>
        <Radio
          {...state.filterContext.registerRadio({ name, value: 'period' })}
          label="Period"
          key="period"
        />
      </div>
      <div className='flex-1'>
        <Radio
          {...state.filterContext.registerRadio({ name, value: 'time' })}
          label="Time"
          key="time"
        />
      </div>
    </Stack>
  }

  return (
    <MenuContent>
      {props.withStatus && <div>
        <Label>Status</Label>
        <div className='flex flex-wrap flex-row gap-x-4'>
          {statusMaster.map(renderStatusItem)}
        </div>
      </div>}
      {props.withTime && (
        <div>
          <Label>Time</Label>
          <Stack direction="row">
            {renderRadioYesNo('time')}
          </Stack>
          <Stack direction='row' className='border-t pt-4 mt-4 border-neutral-200 '>
            <DatePicker
              placeholder="Select date"
              onChange={state.action.handleChangeStartTime}
              format="DD/MM/YYYY"
              value={state.filterContext.draft?.start_date}
              range={false}
              multiple={false}
              label="Start Date"
            />
            <DatePicker
              placeholder="Select date"
              onChange={state.action.handleChangeEndTime}
              format="DD/MM/YYYY"
              value={state.filterContext.draft?.end_date}
              range={false}
              multiple={false}
              label="End Date"
            />
          </Stack>
        </div>
      )}
    </MenuContent>
  )
}

FilterMenuContentParticipant.defaultProps = {
  withTime: false,
  withStatus: false,
  withStatusSuspended: true,
  withStatusDeleted: true,
  withStatusActive: true,
} as FilterMenuContentParticipantProps

export { FilterMenuContentParticipant }
